/* ica-quote-form.js — /pages/talk-to-a-coating-expert arrival + submit handler.
   Reads URL params, renders the Project Basket panel (State A) or the
   escalation success state (State B), and fires `quote_submitted` on the
   contact-form submission. Reference-number format documented in
   sections/ica-quote-engineer-form.liquid:
     ICA-Q-{YYYY}-{MM}-{DD}-{XXXX}   (XXXX = random 4 digits at submit time)

   Loaded only on /pages/talk-to-a-coating-expert via the section's defer script tag.
*/
(function () {
  'use strict';

  var STORAGE_KEY = 'ica_quote_basket_v1';

  function getBackend() {
    function test(s) {
      try { var k='__test__'; s.setItem(k,'1'); s.removeItem(k); return true; } catch (e) { return false; }
    }
    if (window.localStorage && test(window.localStorage)) return window.localStorage;
    if (window.sessionStorage && test(window.sessionStorage)) return window.sessionStorage;
    return null;
  }

  function readBasket() {
    var b = getBackend();
    if (!b) return [];
    try {
      var raw = b.getItem(STORAGE_KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }

  function clearBasket() {
    var b = getBackend();
    if (b) {
      try { b.removeItem(STORAGE_KEY); } catch (e) { /* silent */ }
    }
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function generateRef() {
    var d = new Date();
    var y = d.getFullYear();
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var day = String(d.getDate()).padStart(2, '0');
    var suffix = String(Math.floor(Math.random() * 10000)).padStart(4, '0');
    return 'ICA-Q-' + y + '-' + m + '-' + day + '-' + suffix;
  }

  function getURLParam(name) {
    try {
      var p = new URLSearchParams(window.location.search);
      return p.get(name);
    } catch (e) { return null; }
  }

  function renderBasketPanel(basket) {
    var section = document.querySelector('[data-ica-quote-form-basket]');
    var rowsEl = document.querySelector('[data-ica-quote-form-basket-rows]');
    var countEl = document.querySelector('[data-ica-quote-form-basket-count]');
    if (!section || !rowsEl) return;

    if (basket.length === 0) {
      section.setAttribute('hidden', '');
      return;
    }
    section.removeAttribute('hidden');
    if (countEl) countEl.textContent = '· ' + basket.length + ' item' + (basket.length === 1 ? '' : 's');

    var html = '';
    for (var i = 0; i < basket.length; i++) {
      var it = basket[i];
      var brand = escapeHtml(it.brand || '');
      var line = escapeHtml(it.product_line || '');
      var role = '';
      var meta = [];
      if (brand) meta.push(brand);
      if (line) meta.push(line + ' line');
      var notes = it.notes ? '<div class="ica-quote-form-basket-row-notes"><strong>Notes:</strong> ' + escapeHtml(it.notes) + '</div>' : '';
      html += '' +
        '<div class="ica-quote-form-basket-row">' +
          '<div class="ica-quote-form-basket-row-thumb">' +
            (it.image_src ? '<img src="' + escapeHtml(it.image_src) + '" alt="' + escapeHtml(it.title) + '" width="56" height="56" loading="lazy">' : '') +
          '</div>' +
          '<div class="ica-quote-form-basket-row-info">' +
            '<div class="ica-quote-form-basket-row-title">' + escapeHtml(it.title) + '</div>' +
            (meta.length ? '<div class="ica-quote-form-basket-row-meta">' + meta.map(escapeHtml).join(' · ') + '</div>' : '') +
            notes +
          '</div>' +
          '<div class="ica-quote-form-basket-row-qty">' +
            '<div class="ica-quote-form-basket-row-qty-label">Qty</div>' +
            '<div class="ica-quote-form-basket-row-qty-val">' + (parseInt(it.qty, 10) || 1) + '</div>' +
          '</div>' +
        '</div>';
    }
    rowsEl.innerHTML = html;
  }

  function showEmptyBanner() {
    var b = document.querySelector('[data-ica-quote-form-banner]');
    if (b) b.removeAttribute('hidden');
  }

  function hideEmptyBanner() {
    var b = document.querySelector('[data-ica-quote-form-banner]');
    if (b) b.setAttribute('hidden', '');
  }

  function hideBasketPanel() {
    var s = document.querySelector('[data-ica-quote-form-basket]');
    if (s) s.setAttribute('hidden', '');
  }

  function hideForm() {
    var f = document.querySelector('[data-ica-quote-form-fields]');
    if (f) f.setAttribute('hidden', '');
  }

  function showSuccess(basket) {
    var success = document.querySelector('[data-ica-quote-form-success]');
    var form = document.querySelector('[data-ica-quote-form-fields]');
    var basketPanel = document.querySelector('[data-ica-quote-form-basket]');
    var banner = document.querySelector('[data-ica-quote-form-banner]');
    if (form) form.setAttribute('hidden', '');
    if (basketPanel) basketPanel.setAttribute('hidden', '');
    if (banner) banner.setAttribute('hidden', '');
    if (success) {
      // Ref number — use posted ref from URL if present (form preserved hidden
      // input → Shopify reflects ?contact_posted=true but not custom fields),
      // otherwise generate fresh.
      var ref = sessionStorage.getItem('ica_quote_last_ref') || generateRef();
      var refEl = success.querySelector('[data-ica-quote-success-ref]');
      if (refEl) refEl.textContent = ref;
      success.removeAttribute('hidden');
      // Scroll into view on first paint
      try { success.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { /* silent */ }
    }
    clearBasket();
    sessionStorage.removeItem('ica_quote_last_ref');
  }

  // P9 (F) — Read shipping-address + market + contact traits off the form so
  // every lead event carries the data the Klaviyo identify call needs.
  function collectLeadTraits(form) {
    function val(name) {
      var el = form.querySelector('[name="contact[' + name + ']"]');
      return el ? (el.value || '') : '';
    }
    var t = {
      contact_name: val('name'),
      contact_email: val('email'),
      company: val('company'),
      phone: val('phone'),
      ship_address1: val('ship_address1'),
      ship_city: val('ship_city'),
      ship_region: val('ship_region'),
      ship_zip: val('ship_zip'),
      ship_country: val('ship_country'),
      market: val('market'),
      market_team_entity: val('market_team_entity'),
      market_team_email: val('market_team_email')
    };
    // Drop empties so partial forms never overwrite an existing profile value.
    Object.keys(t).forEach(function (k) { if (!t[k]) delete t[k]; });
    return t;
  }

  function wireSubmit() {
    var form = document.getElementById('ica-quote-engineer-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      // Inject basket payload + reference into the hidden inputs RIGHT before
      // submit so Shopify carries them in the contact submission email
      var basket = readBasket();
      var refInput = document.querySelector('[data-ica-quote-form-reference]');
      var payloadInput = document.querySelector('[data-ica-quote-form-basket-payload]');
      var ref = generateRef();
      if (refInput) refInput.value = ref;
      if (payloadInput) {
        var payload = basket.map(function (it) {
          var line = it.title;
          line += ' [qty: ' + (parseInt(it.qty, 10) || 1) + ']';
          if (it.handle) line += ' (handle: ' + it.handle + ')';
          if (it.notes) line += '\n    Notes: ' + it.notes;
          return line;
        }).join('\n');
        payloadInput.value = payload;
      }
      try { sessionStorage.setItem('ica_quote_last_ref', ref); } catch (e) { /* silent */ }

      // Fire `quote_submitted` BEFORE the page navigates (Shopify redirects
      // after a successful form post). r5 Fix #4 — contact[project_name]
      // replaced by contact[brief_project_description]; payload key shifts
      // in lockstep (was project_name, now brief_description).
      var leadTraits = collectLeadTraits(form);
      if (window.icaEvents && typeof window.icaEvents.fire === 'function') {
        try {
          var qsPayload = {
            brief_description: (form.querySelector('[name="contact[brief_project_description]"]') || {}).value || '',
            industry: (form.querySelector('[name="contact[industry]"]') || {}).value || '',
            total_sqm: null,
            line_items_count: basket.length,
            est_value: null,
            reference: ref
          };
          Object.keys(leadTraits).forEach(function (k) { qsPayload[k] = leadTraits[k]; });
          window.icaEvents.fire('quote_submitted', qsPayload);
        } catch (er) { /* silent */ }
      }

      // Tier 1 #7b — BRDG event #10: inspection_quote_requested.
      // Only fires when the form was loaded with ?intent=inspection_quote
      // (the hidden contact[intent] input is populated by JS bootstrap at
      // page load — see init() below). Payload mirrors the spec §3 contract.
      var intentField = form.querySelector('[name="contact[intent]"]');
      var intentVal = intentField ? (intentField.value || '') : '';
      if (intentVal === 'inspection_quote' &&
          window.icaEvents && typeof window.icaEvents.fire === 'function') {
        try {
          var scopeField = form.querySelector('[name="contact[inspection_scope]"]');
          var companyField = form.querySelector('[name="contact[company]"]');
          var nameField = form.querySelector('[name="contact[name]"]');
          var emailField = form.querySelector('[name="contact[email]"]');
          var descField = form.querySelector('[name="contact[brief_project_description]"]');
          var referrerField = form.querySelector('[name="contact[page_referrer]"]');
          var regionField = form.querySelector('[name="contact[region]"]');
          var iqPayload = {
            intent: 'inspection_quote',
            inspection_scope: scopeField ? (scopeField.value || '') : '',
            company: companyField ? (companyField.value || '') : '',
            country: regionField ? (regionField.value || '') : '',
            contact_name: nameField ? (nameField.value || '') : '',
            contact_email: emailField ? (emailField.value || '') : '',
            project_description: descField ? (descField.value || '') : '',
            page_referrer: referrerField ? (referrerField.value || '') : '',
            timestamp: new Date().toISOString(),
            reference: ref
          };
          Object.keys(leadTraits).forEach(function (k) {
            if (iqPayload[k] === undefined || iqPayload[k] === '') iqPayload[k] = leadTraits[k];
          });
          window.icaEvents.fire('inspection_quote_requested', iqPayload);
        } catch (er) { /* silent */ }
      }
    });
  }

  // Inspection-intent bootstrap. Reads ?intent=inspection_quote on the URL
  // and (a) un-hides the inspection_scope select + intent banner, (b) fills
  // the hidden contact[intent] field, (c) captures document.referrer into
  // contact[page_referrer], (d) makes the select required client-side.
  function wireInspectionIntent(intentParam) {
    if (intentParam !== 'inspection_quote') return;

    var intentField = document.querySelector('[data-ica-form-intent]');
    if (intentField) intentField.value = 'inspection_quote';

    var referrerField = document.querySelector('[data-ica-form-referrer]');
    if (referrerField) {
      try {
        referrerField.value = document.referrer || '';
      } catch (e) { /* silent */ }
    }

    var scopeRow = document.querySelector('[data-ica-insp-scope-row]');
    if (scopeRow) scopeRow.removeAttribute('hidden');

    var scopeSelect = document.querySelector('[data-ica-insp-scope-select]');
    if (scopeSelect) scopeSelect.setAttribute('required', 'required');

    var banner = document.querySelector('[data-ica-insp-intent-banner]');
    if (banner) banner.removeAttribute('hidden');
  }

  /* r5 Fix #4 — Optional-fields accordion handler.
     Default state: panel hidden, aria-expanded=false, caret "▼", label
     "Add project details (optional)". On expand: un-hide panel, flip aria,
     swap caret to "▲" and label to "Hide project details", fire new BRDG
     event #15 `quote_form_expanded` (no counter — same pattern as the 4
     Quote-Cart events per Decision #11). Event fires ONLY on expand, not
     on collapse. */
  function wireFormExpander() {
    var expander = document.querySelector('[data-ica-form-expander]');
    var panel = document.querySelector('[data-ica-form-optional]');
    if (!expander || !panel) return;
    var caret = expander.querySelector('[data-ica-form-expander-caret]');
    var label = expander.querySelector('[data-ica-form-expander-label]');
    expander.addEventListener('click', function () {
      var isExpanded = expander.getAttribute('aria-expanded') === 'true';
      var willExpand = !isExpanded;
      expander.setAttribute('aria-expanded', String(willExpand));
      if (willExpand) {
        panel.removeAttribute('hidden');
        if (caret) caret.textContent = '▲';
        if (label) label.textContent = 'Hide project details';
        if (window.icaEvents && typeof window.icaEvents.fire === 'function') {
          try {
            window.icaEvents.fire('quote_form_expanded', {
              source: 'contact_form',
              expanded_at: new Date().toISOString()
            });
          } catch (er) { /* silent */ }
        }
      } else {
        panel.setAttribute('hidden', '');
        if (caret) caret.textContent = '▼';
        if (label) label.textContent = 'Add project details (optional)';
      }
    });
  }

  /* P9 (F) — Collapsible shipping-address toggle. Same a11y pattern as the
     project-details expander; no event fired (low-signal vs. quote_form_expanded). */
  function wireShipExpander() {
    var expander = document.querySelector('[data-ica-ship-expander]');
    var panel = document.querySelector('[data-ica-ship-panel]');
    if (!expander || !panel) return;
    var caret = expander.querySelector('[data-ica-ship-expander-caret]');
    var labelEl = expander.querySelector('.ica-form-expander-label');
    expander.addEventListener('click', function () {
      var willExpand = expander.getAttribute('aria-expanded') !== 'true';
      expander.setAttribute('aria-expanded', String(willExpand));
      if (willExpand) {
        panel.removeAttribute('hidden');
        if (caret) caret.textContent = '▲';
        if (labelEl) labelEl.textContent = 'Hide shipping address';
      } else {
        panel.setAttribute('hidden', '');
        if (caret) caret.textContent = '▼';
        if (labelEl) labelEl.textContent = 'Add shipping address (optional)';
      }
    });
  }

  function init() {
    var page = document.querySelector('[data-ica-quote-form-page]');
    if (!page) return;

    var intent = getURLParam('intent');
    var posted = getURLParam('contact_posted');
    var posted2 = getURLParam('form_type'); // Shopify sets ?form_type=contact on successful POST redirect

    // STATE B — Success
    // Success is detected by EITHER:
    //   (a) ?contact_posted=true / =1 on the URL, OR
    //   (b) Fix #1 — the server-rendered success block carries
    //       data-ica-form-posted="true". That block is ONLY emitted by the
    //       Liquid when form.posted_successfully? is true (real submit), so
    //       its mere presence is authoritative. This covers the case where
    //       Shopify re-renders the page on success WITHOUT appending the
    //       contact_posted param to the URL. The confirmation + reference
    //       are never in the DOM (let alone visible) until a real submit.
    var postedFlagEl = document.querySelector('[data-ica-quote-form-success][data-ica-form-posted="true"]');
    if (posted === 'true' || posted === '1' || postedFlagEl) {
      showSuccess(readBasket());
      return;
    }

    // STATE A — Quote intent: render basket panel.
    // B5 Fix 1 — the empty-basket banner and the basket panel are MUTUALLY
    // EXCLUSIVE. Read the HYDRATED localStorage basket and gate strictly on
    // count: banner ONLY when genuinely empty (count === 0); when count > 0,
    // explicitly keep the banner hidden and render the panel. (The CSS fix
    // .ica-quote-form-banner[hidden] is the root cause; this is belt-and-braces
    // so intent is explicit in JS too.)
    if (intent === 'quote') {
      var basket = readBasket();
      if (basket.length === 0) {
        hideBasketPanel();
        showEmptyBanner();
      } else {
        hideEmptyBanner();
        renderBasketPanel(basket);
      }
    } else {
      // Not the quote intent — the empty-basket banner must never show.
      hideEmptyBanner();
      // STATE A' — Single-product fallback (?product={handle})
      // Covers (a) Q12 silent-degradation path when localStorage is disabled,
      // (b) legacy PDP Request-Quote links from before Quote-Cart shipped, and
      // (c) external inbound links. Gated on !intent so multi-product basket
      // always wins per Section 8 behaviour-matrix precedence.
      var productHandle = getURLParam('product');
      if (productHandle) {
        var industryParam = getURLParam('industry');
        var humanProduct = decodeURIComponent(productHandle).replace(/-/g, ' ');
        var notesField = document.querySelector('[name="contact[special_requirements]"]');
        if (notesField && !notesField.value) {
          notesField.value = 'Quote request for: ' + humanProduct;
        }
        var payloadField = document.querySelector('[name="contact[basket_payload]"]');
        if (payloadField) {
          payloadField.value = JSON.stringify({
            mode: 'single_product',
            product_handle: productHandle,
            industry: industryParam || null
          });
        }
        if (industryParam) {
          var industrySelect = document.querySelector('[name="contact[industry]"]');
          if (industrySelect) {
            var match = industrySelect.querySelector('option[value="' + industryParam + '"]');
            if (match) industrySelect.value = industryParam;
          }
        }
      }
    }

    // Inspection-intent rendering — runs alongside the basket logic
    // because the inspection intent does NOT carry a Quote-Cart basket.
    wireInspectionIntent(intent);

    // Otherwise: default render (just the form, no basket)
    wireSubmit();
    wireFormExpander();
    wireShipExpander();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
